import { useState, useEffect } from "react";
import { X } from "lucide-react";
import axios from "axios";
import { API } from "../App";

const EMOJIS = [
  "😀", "😃", "😄", "😁", "😅", "😂", "🤣", "😊",
  "😇", "🙂", "🙃", "😉", "😌", "😍", "🥰", "😘",
  "😗", "😙", "😚", "😋", "😛", "😜", "🤪", "😝",
  "🤑", "🤗", "🤭", "🤫", "🤔", "🤐", "🤨", "😐",
  "😑", "😶", "😏", "😒", "🙄", "😬", "🤥", "😌",
  "😔", "😪", "🤤", "😴", "😷", "🤒", "🤕", "🤢",
  "🤮", "🤧", "🥵", "🥶", "🥴", "😵", "🤯", "🤠",
  "🥳", "😎", "🤓", "🧐", "😕", "😟", "🙁", "☹️",
  "😮", "😯", "😲", "😳", "🥺", "😦", "😧", "😨",
  "😰", "😥", "😢", "😭", "😱", "😖", "😣", "😞",
  "😓", "😩", "😫", "🥱", "😤", "😡", "😠", "🤬",
  "👍", "👎", "👊", "✊", "🤛", "🤜", "🤞", "✌️",
  "🤟", "🤘", "👌", "🤏", "👈", "👉", "👆", "👇",
  "☝️", "✋", "🤚", "🖐", "🖖", "👋", "🤙", "💪",
  "❤️", "🧡", "💛", "💚", "💙", "💜", "🖤", "🤍",
  "💔", "❣️", "💕", "💞", "💓", "💗", "💖", "💘"
];

const EmojiPicker = ({ onSelect, onClose }) => {
  const [activeTab, setActiveTab] = useState("smileys");
  const [customSmileys, setCustomSmileys] = useState([]);

  useEffect(() => {
    // Fetch custom smileys
    axios.get(`${API}/smileys`)
      .then(res => setCustomSmileys(res.data.smileys || []))
      .catch(err => console.error("Failed to load smileys:", err));
  }, []);

  return (
    <div className="retro-window w-80" data-testid="emoji-picker">
      <div className="retro-title-bar">
        <span>Select Emoticon</span>
        <button 
          className="retro-button px-2 py-0 text-xs"
          onClick={onClose}
        >
          <X className="w-3 h-3" />
        </button>
      </div>
      
      {/* Tabs */}
      <div className="bg-[#C0C0C0] border-b border-[#808080] flex">
        <button
          className={`px-3 py-1 text-xs font-bold ${activeTab === 'smileys' ? 'bg-[#E0E0E0] border-t-2 border-t-blue-500' : 'hover:bg-[#D0D0D0]'}`}
          onClick={() => setActiveTab('smileys')}
          data-testid="smileys-tab"
        >
          🎭 Smileys
        </button>
        <button
          className={`px-3 py-1 text-xs font-bold ${activeTab === 'emoji' ? 'bg-[#E0E0E0] border-t-2 border-t-blue-500' : 'hover:bg-[#D0D0D0]'}`}
          onClick={() => setActiveTab('emoji')}
          data-testid="emoji-tab"
        >
          😀 Emoji
        </button>
      </div>
      
      <div className="p-1 bg-[#C0C0C0]">
        <div className="retro-inset">
          {/* Custom Smileys Tab */}
          {activeTab === 'smileys' && (
            <div className="max-h-48 overflow-y-auto retro-scrollbar p-2">
              {customSmileys.length === 0 ? (
                <p className="text-xs text-[#808080] text-center py-4">Loading smileys...</p>
              ) : (
                <div className="grid grid-cols-5 gap-2">
                  {customSmileys.map((smiley, index) => (
                    <button
                      key={smiley.code}
                      className="p-1 hover:bg-[#B0B0B0] rounded flex flex-col items-center"
                      onClick={() => onSelect(smiley.code)}
                      title={smiley.code}
                      data-testid={`smiley-${index}`}
                    >
                      <img 
                        src={`${process.env.REACT_APP_BACKEND_URL}${smiley.url}`} 
                        alt={smiley.name} 
                        className="w-8 h-8 object-contain"
                      />
                      <span className="text-[8px] text-[#808080] mt-0.5">{smiley.code}</span>
                    </button>
                  ))}
                </div>
              )}
              <p className="text-[9px] text-[#808080] text-center mt-2 border-t border-[#808080] pt-1">
                Type the code (e.g. {"{bear}"}) in chat to use
              </p>
            </div>
          )}
          
          {/* Standard Emoji Tab */}
          {activeTab === 'emoji' && (
            <div className="emoji-grid max-h-48 overflow-y-auto retro-scrollbar">
              {EMOJIS.map((emoji, index) => (
                <button
                  key={index}
                  className="emoji-item"
                  onClick={() => onSelect(emoji)}
                  data-testid={`emoji-${index}`}
                >
                  {emoji}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmojiPicker;
